import React from 'react'
import PropTypes from 'prop-types'
import { Container } from 'reactstrap'
import XactLoanDisclosure from './XactLoanDisclosure'
import CaliforniaNotice from 'shared/components/Footer/CaliforniaNotice'
import Branding from 'shared/branding'
import { ONLINE_STORE_BRAND_NAME } from 'constants/values'
import { FooterLinks } from 'shared/components'
import PatriotActDisclosure from './PatriotActDisclosure'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { APPLICATION_PATHS } from 'constants/paths'
import XactIlpTermFooter from './XactILPTermFooter'
import RefinanceDisclosure from './RefinanceDisclosure'


const Footer = ({
  copyrightYear,
  footerLinks,
  showClp,
  isEpp,
  showBank,
  showStandardArticles,
}) => {
  const {
    hideHawaiiFooter,
    hideKyIaFooter,
    enableDebitCardForFlow,
  } = useFlags()
  const { brands: acceptedBrandsForFunding } = enableDebitCardForFlow

  let counter = 1

  const californiaDepartment =
    'California Department of Financial Protection and Innovation'

  const retailStates = isEpp
    ? `Alabama, Delaware, Idaho, ${hideKyIaFooter ? '' : 'Iowa,'} ${hideKyIaFooter ? '' : 'Kentucky,'
    } Michigan, Missouri, Oklahoma, South Carolina, Texas, Utah and Wisconsin`
    : `Alabama, Delaware, Idaho, ${hideKyIaFooter ? '' : 'Iowa,'} ${hideKyIaFooter ? '' : 'Kentucky,'
    } Michigan, Missouri, Oklahoma, South Carolina, Texas, Utah and Wisconsin`

  const path = window.location.pathname
  const shouldNotApplytopMargin =
    path === APPLICATION_PATHS.LEAD_AGREEMENTS ||
    path.indexOf(APPLICATION_PATHS.NOT_APPROVED_LEAD_WELCOME) > -1

  return (
    <footer
      role="contentinfo"
      id="footer"
      className={shouldNotApplytopMargin ? '' : 'mt-5'}
    >
      <Container>
        <FooterLinks footerLinks={footerLinks} />

        <h3
          data-test="text.online-disclosures-heading"
          id="online-disclosures-header"
        >
          Online Disclosures
        </h3>

        <PatriotActDisclosure />

        <div data-test="etc.online-disclosures" id="footer-content">
          <p>
            <strong>Customer Notice:</strong> Payday Loans are typically for
            two-to four-week terms. Some borrowers, however, use Payday Loans
            for several months, which can be expensive. Payday Loans (also
            referred to as Payday Advances, Cash Advances, Deferred Deposit
            Transactions/Loans) and high-interest loans should be used for
            short-term financial needs only and not as a long-term financial
            solution. Customers with credit difficulties should seek credit
            counseling before entering into any loan transaction. See{' '}
            <a
              title="Check `n Go State Center"
              href="https://www.checkngo.com/resources/state-center/"
              target="_blank"
              rel="noopener noreferrer"
            >
              State Center
            </a>{' '}
            for specific information and requirements.
          </p>
          <p>
            {' '}
            {showStandardArticles && (
              <React.Fragment>
                California licensed by the {californiaDepartment} pursuant to
                the California Deferred Deposit Transaction Law.{' '}
              </React.Fragment>
            )}
            Texas loans originate by a third party lender, restrictions apply.
            Delaware licensed lender by the Delaware State Banking Commissioner,
            expires 12/31/
            {copyrightYear}.
          </p>
          <p>
            Check `n Go is not a direct lender in Texas, where instead it acts
            in the capacity as a Credit Services Organization.
          </p>
          <p data-test="test.disclosures.standardExample">
            {!isEpp && `${counter++}. `}
            Approval depends upon meeting legal, regulatory and underwriting
            requirements.{' '}
            {acceptedBrandsForFunding.includes(Branding.current.key)
              ? `Originated loans can be funded in as little as 30
            minutes to a Visa debit card. Funding times may vary based on the
            consumer debit card bank. Funding to a MasterCard may be subject to
            restrictions. Funding by ACH may occur as soon as the same day.`
              : `If approved and originated by 8:00 pm ET on a business day,
            online loans are typically funded no later than the following business day. `}
            Retail applications completed online can obtain a "Conditional
            Approval" at any time. Retail locations can provide funds, upon
            approval, during regular business hours. Check{' '}
            <a
              title="Check`n Go"
              href="https://locations.checkngo.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="pseudolink"
            >
              https://locations.checkngo.com
            </a>{' '}
            for detail on store information. All times and dates are based on
            Eastern Time (ET). Online amounts may vary by state. Please see the
            website for details. All products and service options are subject to
            change without notice. Check `n Go may report customer loan
            information to one or more credit reporting agencies. Late payments,
            missed payments and other events of default may be reflected in
            customer credit reports. See{' '}
            <a
              title="Check`n Go"
              href="https://www.checkngo.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              checkngo.com
            </a>{' '}
            for details. The lender may, at their discretion, verify application
            information by using national databases that may provide information
            from one or more national credit bureaus, and the lender may take
            that into consideration in the approval process.
          </p>

          {Branding.current.key === 'CNG' && (
            <p>
              {counter++}. Actual loan amount and terms will vary based on final evaluation
              and credit qualifications.
            </p>
          )}

          <RefinanceDisclosure
            counter={counter}
            isRefinance={!showStandardArticles}
          />

          {window.location.pathname.indexOf(
            APPLICATION_PATHS.NOT_APPROVED_LEAD_WELCOME
          ) > -1 && (
              <p>
                {counter++}. Payments must be made on time in order to enhance
                credit with lender.
              </p>
            )}

          {showBank && showStandardArticles && (
            <XactIlpTermFooter
              counter={counter++}
              examples={showBank.xactExamples}
              data-test="test.disclosures.xactExample"
            />
          )}

          {showClp && showStandardArticles && (
            <p data-test="test.disclosures.ilpExample-2">
              {counter++}. Actual loan amount and terms will vary based on final
              evaluation of income and credit qualifications. Payment amounts
              vary by rate.
            </p>
          )}

          <p>
            Check `n Go and third parties verify application information by
            using national databases that may provide information from one or
            more national credit bureaus, and Check `n Go or third parties may
            take that into consideration in the approval process.
          </p>

          <p>We do not report credit in Texas.</p>

          <p>
            Products or services offered to customers may vary based on customer
            eligibility and applicable state or federal law. All available
            products subject to applicable lender’s terms and conditions. Actual
            loan amounts vary. See{' '}
            <a
              title="Check `n Go State Center"
              href="https://www.checkngo.com/resources/state-center/"
              target="_blank"
              rel="noopener noreferrer"
              className="pseudolink"
            >
              State Center
            </a>{' '}
            for specific information and requirements.
          </p>

          {window.location.pathname === APPLICATION_PATHS.ACCOUNT && (
            <p>*Active checking account open for at least 30 days.</p>
          )}

          <p>
            ** Check `n Go doesn&apos;t charge you for using text messages (SMS)
            for two-factor authentication. However, your mobile provider&apos;s
            standard rates for sending and receiving messages may apply.
          </p>
          <p>
            &dagger; By providing your telephone number, including any mobile
            number, you consent that we may call you at these numbers for
            servicing and marketing telephone calls.
          </p>

          {showBank && <XactLoanDisclosure />}

          <p>
            Check `n Go currently operates online in: Alabama, California,
            Delaware, Florida, {hideHawaiiFooter ? '' : 'Hawaii,'} Idaho,
            Indiana, Kansas, Michigan, Missouri, Oklahoma, South Carolina,
            Texas, Utah, and Wisconsin.
          </p>
          <p>
            Check `n Go currently operates in store locations in: {retailStates}
            .
          </p>

          <p>
            CALIFORNIA RESIDENTS: If you are married, you may apply for an
            account separate from your spouse.
          </p>

          <p className="debt-disclaimer">
            The Company, individually or through its affiliates, is licensed as
            a Debt Collector by the California Department of Financial
            Protection and Innovation (DFPI), License Number 10435-99.
          </p>



          {showStandardArticles && (
            <CaliforniaNotice
              strong={false}
              brand={Branding.getBrand(ONLINE_STORE_BRAND_NAME.CNG).name}
            />
          )}
          {Branding.current.key === 'CNG' && (
            <p>
              Notice to Missouri consumers: This lender offers short-term loans.
              Please read and understand the terms of the loan agreement before
              signing. The maximum annual percentage rate currently being
              charged on 14-day loans at this website is 443.57%. This lender
              is regulated by the Missouri Division of Finance, P.O. Box 716,
              Jefferson City, Missouri 65102-0716. Phone <a href="tel:5737513463">(573) 751-3463</a>
            </p>
          )}

          <span data-test="text.copyright">
            &copy; {copyrightYear} Check `n Go. All rights reserved.
            <address>PO Box 36454, Cincinnati, OH 45236</address>
          </span>
        </div>
      </Container>
    </footer>
  )
}

Footer.displayName = 'Footer'
Footer.propTypes = {
  copyrightYear: PropTypes.number.isRequired,
  showClp: PropTypes.object,
  showBank: PropTypes.object,
  footerLinks: PropTypes.array,
  isEpp: PropTypes.bool,
  showStandardArticles: PropTypes.bool,
}

export default Footer
